module.exports = __webpack_public_path__ + "media/assets/icons/chevron-small-up-d92f40a46af502d36d61563d14c2cb2c.svg";